import React from 'react'

import Banner from 'images/dashboard/banners/competition.png'

function Competition({}) {
  return (
    <div className="row banner-section">
      <div className="col-12 banner-container">
        <a href="/digital-art-competition" target="_blank">
          <img src={Banner} alt="Digital Art Competition" />
        </a>
      </div>
    </div>
  )
}

export default Competition
